import { generateUUID } from "./deco";
//todo json差异化比较
const BottomTabJson = {
  name: 'Tab',
  type: 'general',
  top_left_source: {
    type: "material_group",
    params: {
      "material_group_id": ''
    }
  },
  top_right_source: {
    type: "material_group",
    params: {
      "material_group_id": ''
    }
  },
  navigationbar: {
    color_select: '#000000',
    color_default: '#888282',
    position: 'left',
    title_size: 18,
    tabs: [], //TabJson
  },
  titlebar: {
    title: '单tab标题',
    anchor_sid: '',
    exist: 1,
    component_list_config: [],
  },
  config: {
    is_need_login: 0,
    is_vip: 0,
    is_dark: 0
  },
  //图标 id+url
  icons: {
    normal_icon: '',
    select_icon: '',
    normal_dark_icon: '',
    select_dark_icon: '',
  },
  ignore: {
    normal_icon_url: '',
    select_icon_url: '',
    normal_dark_icon_url: '',
    select_dark_icon_url: '',
    top_left_source_name: '',
    top_right_source_name: '',
  }
};
const AppJson = {
  left1: JSON.parse(JSON.stringify(BottomTabJson)),
  left2: JSON.parse(JSON.stringify(BottomTabJson)),
  right1: JSON.parse(JSON.stringify(BottomTabJson)),
  right2: JSON.parse(JSON.stringify(BottomTabJson)),
  config: {
    bottom_tab_style: 'icon',//底部tab样式 icon/text
    show_buy: 0,//显示内购
  }
};

function newApp() {
  const app = JSON.parse(JSON.stringify(AppJson))
  app.left1.titlebar.anchor_sid = generateUUID()
  app.left2.titlebar.anchor_sid = generateUUID()
  app.right1.titlebar.anchor_sid = generateUUID()
  app.right2.titlebar.anchor_sid = generateUUID()
  return app
}


//组件的source
//https://ek638u.yuque.com/ek638u/sgmqot/qzkaqx8zkqe9gmoo#SxXgj
const ComponentSourceJson = {
  type: 'material_group',//
  params: {
    material_group_id: '',//对应material_group
    material_id: '',//对应material
    category_id: '',//对应 category_tags
    tag_group_id: '',//同上
    tag_id_list: [],//图片标签数组  [1, 2, 3],对应tags
    tag_id: '',//tag_photos-标签图片复合
    total: 6,//
  },
  ignore: {

  }
}


// 是否无尽循环
// 切换时间
// 创建素材组｜编辑素材组（⚠️：素材组有多少个素材，banner就显示多少个，不做参数，约定好）
// 元素间距
// (单)元素宽
// (单)元素高
// (单)元素圆角
// 指示器是否需展示
const BannerJson = {
  type: 'banner',
  name: 'Banner',
  banner_params: {
    margin: 15,
    item_height_ratio: 33,
    corner_radius: 5,
    show_indicator: 1,
    delay_time: 3,
  },
  component_source: {
    type: 'material_group',
    params: {
      material_group_id: 1,
    }
  },
  //冗余信息
  ignore: {
    material_group_name: ''
  }
};

// 标题文字
// 展示个数
// 创建素材组
// 元素间距
// (单)元素宽
// (单)元素高
// (单)元素圆角
const WordBannerJson = {
  type: 'word_banner',
  name: 'WordBanner',
  word_banner_params: {
    title: '标题',
    number: 5,
    between_space: 10,
    item_width: 100,
    item_height: 40,
    corner_radius: 4,
    margin: 15,
  },
  component_source: {
    type: 'material_group',
    params: {
      material_group_id: 1,
    }
  },
  //冗余信息
  ignore: {
    material_group_name: ''
  }
};

// 搜索展示文字
// 文字颜色
// 文字位置
// 是否展示按钮
// 按钮文字
// 按钮颜色
// icon上传
const SearchbarJson = {
  type: 'searchbar',
  name: '搜索框',
  searchbar_params: {
    text: '搜索你感兴趣的内容',
    text_color: '#BFC4CD',
    text_position: 'left',
    show_button: 0,
    button_text: '搜索',
    button_color: '#70FFA9',
  },
};

// 标题文字
// 展示文字
// 展示文字是否显示
// 展示个数
// 数据来源（手动、自动）
// 手动：创建素材组/选择大栏目+标签
// 元素间距
// (单)元素宽
// (单)元素高
// (单)元素圆角
const PhotoClassifyJson = {
  type: 'photo_classify',
  name: 'PhotoClassify',
  photo_classify_params: {
    title: 'PhotoClassify',
    column: 3,//默认三列
    between_space: 10,
    item_height_ratio: 150,//相对于宽的比例，100为正方形
    corner_radius: 4,
    margin: 15,
  },
  component_source: ComponentSourceJson
};

const PhotoClassifyPlatJson = {
  type: 'photo_classify_plat',
  name: 'PhotoClassifyPlat',
  photo_classify_plat_params: {
    title: 'PhotoClassifyPlat',
    column: 2,//默认两列
    between_space: 10,
    item_height_ratio: 50,
    corner_radius: 4,
    text_position: 1,//键盘1-9位置
    margin: 15,
    text_show: 1
  },
  component_source: ComponentSourceJson
};


// 标题文字
// 展示文字
// 展示文字是否显示
// 展示个数
// 数据来源（手动、自动）
// 手动：创建素材组/选择大栏目+标签
// 元素间距
// (单)元素宽
// (单)元素高
// (单)元素圆角
const PhotoClassifyLineJson = {
  type: 'photo_classify_line',
  name: 'PhotoClassifyLine',
  photo_classify_line_params: {
    title: 'PhotoClassifyLine',
    between_space: 10,
    item_width: 100,
    item_height: 40,
    corner_radius: 4,
    shadow: 5,
    margin: 15,
  },
  component_source: ComponentSourceJson
};

const PhotoClassifyLineTinyJson = {
  type: 'photo_classify_line_tiny',
  name: 'PhotoClassifyLineTiny',
  photo_classify_line_tiny_params: {
    title: 'PhotoClassifyLineTiny',
    between_space: 10,
    icon_width: 40,
    icon_height: 40,
    corner_radius: 4,
    margin: 15,
  },
  component_source: ComponentSourceJson
};

const PhotoClassifyLineLittleJson = {
  type: 'photo_classify_line_little',
  name: 'PhotoClassifyLineLittle',
  photo_classify_line_little_params: {
    title: 'PhotoClassifyLineLittle',
    between_space: 10,
    icon_width: 54,
    icon_height: 54,
    corner_radius: 4,
    border_width: 1,
    border_color: '#EDEDED',
    item_padding: 10,
    margin: 15,
  },
  component_source: ComponentSourceJson
};

// 标题文字
// 展示文字
// 展示文字是否显示
// 展示个数
// 数据来源（手动、自动）
// 手动：创建素材组/选择大栏目+标签
// 元素间距
// (单)元素宽
// (单)元素高
// (单)元素圆角
const TagPhotosJson = {
  type: 'tag_photos',
  name: 'TagPhotos',
  tag_photos_params: {
    between_space: 10,
    item_width: 100,
    item_height: 150,
    corner_radius: 4,
    margin: 15,
  },
  component_source: ComponentSourceJson
};



const PhotoAlbumJson = {
  type: 'photo_album',
  name: 'PhotoAlbum',
  photo_album_params: {
    title: '标题',
    description: '展示文字',
    show_description: 0,
    number: 0,
    between_space: 10,
    item_width: 100,
    item_height: 40,
    corner_radius: 4,
  },
};


/**
 * 底部列表-壁纸
 */
const BottomListWallpaperJson = {
  type: 'bottom_list_wallpaper',
  name: '底部列表-壁纸',
  bottom_list_wallpaper_params: {
    title: '壁纸列表',
    show_type: 'photolist',//1.图片列表photolist2.瀑布流waterfall
    item_height_ratio: 178,//瀑布流不显示
    margin: 15,
    between_space: 10,
    corner_radius: 4,
    column: 2,
    show_like: 1,
    show_author: 1,
    show_bottom_view: 1,
  },
  source_list: {
    type: 'photos',
    params: {
      category_id: 0,
      tag_id: 0,
      photo_order: 'newest',
      per_page: 18
    },
    ignore: {
      tag_name: '',
      category_name: ''
    }
  }
};

/**
 * 底部列表-头像
 */
const BottomListAvatarJson = {
  type: 'bottom_list_avatar',
  name: '底部列表-头像',
  bottom_list_avatar_params: {
    title: '头像列表',
    margin: 15,
    between_space: 10,
    corner_radius: 4,
    column: 2
  },
  source_list: {
    type: 'photos',
    params: {
      category_id: 0,
      tag_id: 0,
      photo_order: 'newest',
      per_page: 8
    },
    ignore: {}
  }
};

/**
 * 底部列表-表情
 */
const BottomListEmojiJson = {
  type: 'bottom_list_emoji',
  name: '底部列表-表情',
  bottom_list_emoji_params: {
    title: '表情列表',
    margin: 15,
    between_space: 10,
    corner_radius: 4,
    column: 3
  },
  source_list: {
    type: 'photos',
    params: {
      category_id: 0,
      tag_id: 0,
      photo_order: 'newest',
      per_page: 8
    },
    ignore: {}
  }
};

/**
 * 底部列表-主题
 */
const BottomListThemeJson = {
  type: 'bottom_list_theme',
  name: '底部列表-主题',
  bottom_list_theme_params: {
    title: '主题列表',
    show_type: 'photolist',//1.图片列表photolist2.瀑布流waterfall
    item_height_ratio: 178,//瀑布流不显示
    margin: 15,
    between_space: 10,
    corner_radius: 4,
    column: 2,
    show_like: 1,
    show_author: 1,
    show_bottom_view: 1,
  },
  source_list: {
    type: 'themes',
    params: {
      per_page: 8
    },
    ignore: {}
  }
};

/**
 * 底部列表-壁纸标签
 */
const BottomListPhotoTagsJson = {
  type: 'bottom_list_phototags',
  name: '底部列表-壁纸标签',
  bottom_list_phototags_params: {
    title: '壁纸标签列表',
    show_type: 'flat',//1.平铺 flat 2.分类 classify 
    item_height_ratio: 178,
    margin: 15,
    between_space: 10,
    corner_radius: 4,
    column: 2,
    text_position: 5
  },
  source_list: {
    type: 'photo_tags',
    params: {
      category_id: 0,
      tag_group_id: 0,
      per_page: 8,
    },
    ignore: {}
  }
};

/**
 * 底部列表-标签壁纸
 */
const BottomListTagsAndPhotosJson = {
  type: 'bottom_list_tagsandphotos',
  name: '底部列表-标签壁纸',
  bottom_list_tagsandphotos_params: {
    title: '标签壁纸列表',
    item_width: 100,
    item_height: 178,
    margin: 15,
    between_space: 10,
    corner_radius: 4,
  },
  source_list: {
    type: 'tags_and_photos',
    params: {
      category_id: 0,
      tag_group_id: 0,
      per_page: 8,
    },
    ignore: {}
  }
};


/**
 * Tab
 */
const TabJson = {
  name: '标题',
  type: 'component_list', // 1.component_list(组件列表)2.wallpaper_list(大屏列表)
  anchor_sid: '',
  is_default: 0, //是否默认选中
  is_dark: 0,//是否是暗黑模式
  component_list_config: [], //对应type=component_list 组件列表
  //对应type=wallpaper_list 大屏列表配置项
  wallpaper_list_config: {
    params: {
      template: 1,
    },
    source_list: {
      type: 'photos',
      params: {
        category_id: 0,
        tag_id: 0,
      }
    },
    ignore: {}
  },
};

/**
 * 顶部Tab类型
 */
const TabTypeOptions = [
  {
    name: '组件列表',
    value: 'component_list',
  },
  {
    name: '大屏类型',
    value: 'wallpaper_list',
  },
  {
    name: '小组件',
    value: 'widgets',
  },
];


const ComponentListMenu = [BannerJson,
  SearchbarJson,
  WordBannerJson,
  PhotoClassifyJson,
  PhotoClassifyPlatJson,
  PhotoClassifyLineJson,
  PhotoClassifyLineTinyJson,
  PhotoClassifyLineLittleJson,
  TagPhotosJson,
  PhotoAlbumJson,
  BottomListWallpaperJson,
  BottomListAvatarJson,
  BottomListEmojiJson,
  BottomListThemeJson,
  BottomListPhotoTagsJson,
  BottomListTagsAndPhotosJson
]

export {
  newApp,
  ComponentListMenu,
  TabJson,
  TabTypeOptions,
};
